import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import React from 'react';

dayjs.extend(localeData);

export function WeekDays() {
    return (
        <div className={`weekdays`}>
            {dayjs.weekdaysMin(true).map((wd) => (
                <div
                    key={wd}
                    className="weekday"
                >
                    {wd}
                </div>
            ))}
        </div>
    );
}
